import { PAY_RECHARGE } from "@/apis/payment"
export default {
  methods: {
    onEghlPay (payType, paymentId, amount, qrcode, productId, outTradeNo, rechargeType) {
      this.$loading(true)
      let url = PAY_RECHARGE
      let datas = {}
      if (payType === "YJ") {
        datas = {
          paymentId: paymentId,
          rechargeType: rechargeType,
          amount: amount,
          qrCode: qrcode,
          rentNow: true,
          rentalProductType: productId || "",
          enableMultiRedirect: true
        }
      } else {
        datas = {
          outTradeNo: outTradeNo,
          paymentId: paymentId,
          rechargeType: "pay",
          enableMultiRedirect: true
        }
      }
      this.$post(
        url,
        datas,
        (resp) => {
          // this.$loading(false)
          console.log(resp)
          if (resp.data && resp.data.paymentInfo) {
            const paymentInfo = resp.data.paymentInfo
            const formData = {
              'TransactionType': paymentInfo.transactionType,
              'PymtMethod': paymentInfo.pymtMethod,
              'ServiceID': paymentInfo.serviceID,
              'PaymentID': paymentInfo.paymentID,
              'OrderNumber': paymentInfo.orderNumber,
              'PaymentDesc': paymentInfo.paymentDesc,
              'MerchantName': paymentInfo.merchantName,
              'MerchantReturnURL': paymentInfo.merchantReturnURL,
              'MerchantCallbackURL': paymentInfo.merchantCallbackURL,
              'MerchantUnApprovalURL': paymentInfo.merchantUnApprovalURL,
              'MerchantApprovalURL': paymentInfo.merchantApprovalURL,
              'Amount': paymentInfo.amount.toFixed(2),
              'CurrencyCode': paymentInfo.currencyCode,
              'CustIP': paymentInfo.custIP,
              'CustName': paymentInfo.custName || "",
              'CustEmail': paymentInfo.custEmail || "",
              'CustPhone': paymentInfo.custPhone || "",
              'LanguageCode': "en",
              'PageTimeout': paymentInfo.pageTimeout,
              'HashValue': paymentInfo.hashValue,
              'IssuingBank': paymentInfo.issuingBank || ""
            }
            this.createEghlPayForm(paymentInfo.gateway, formData)
          } else {
            this.$loading(false)
          }
        },
        (error) => {
          this.$loading(false)
          console.log(error)
          this.$toast(error)
        },
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8"
          }
        }
      )
    },
    createEghlPayForm (action, formData) {
      const formContainer = document.getElementById('eghlpay-form');
      const form = document.createElement('form');
      form.id = 'autoForm';
      form.method = 'POST';
      form.action = action;

      for (let key in formData) {
        let input = document.createElement('input');
        input.type = 'hidden';
        input.name = key;
        input.value = formData[key];
        form.appendChild(input);
      }

      formContainer.appendChild(form);
      form.submit();
      setTimeout(() => {
        this.$loading(false)
      }, 6000);
    }
  }
}
